// College Content
import Unit5x5 from 'assets/images/psp/College/unit-5x5.svg';
import Unit5x10 from 'assets/images/psp/College/unit-5x10.svg';
import Unit10x10 from 'assets/images/psp/College/unit-10x10.svg';
import Unit10x15 from 'assets/images/psp/College/unit-10x15.svg';
import CollegeHero from 'assets/images/psp/hero/college-hero.webp';
import Box from 'assets/images/psp/College/box.svg';
import Camera from 'assets/images/psp/camera.svg';
import Furniture from 'assets/images/psp/College/furniture.svg';
import Grad from 'assets/images/psp/College/grad.svg';
import Summer from 'assets/images/psp/summer.svg';
import CC from 'assets/images/icons/psp/CC.svg';
import Garage from 'assets/images/psp/garage.svg';
import Featured1 from 'assets/images/psp/FeaturedImages/collegeFeatured1.webp';
import Featured2 from 'assets/images/psp/FeaturedImages/collegeFeatured2.webp';
import Featured3 from 'assets/images/psp/FeaturedImages/collegeFeatured3.webp';

const reviews = [
	{
		reviewTitle: 'The unit was exactly what I was looking for!',
		reviewRating: 5,
		reviewText:
			'The unit was exactly what I was looking for! We needed storage for my granddaughter to use for the summer, coming home from college. We found a convenient location to her college and the price was affordable.',
		reviewerName: 'Nancy Cole',
		reviewerInitials: 'NC',

		reviewDate: 'Mar 13, 2024',
		link: 'https://www.trustpilot.com/reviews/65f1c808d9f5f2a3af432a84',
	},
	{
		reviewTitle: 'Process was easy…',
		reviewRating: 5,
		reviewText:
			"The storage search process was easy. The experience really calmed a college student parent's nerves.",
		reviewerName: 'Jill',
		reviewerInitials: 'J',

		reviewDate: 'Apr 30, 2022',
		link: 'https://www.trustpilot.com/reviews/626c2aeb166eb7ecbf387282',
	},
	{
		reviewTitle: 'Storage for your college student over the summer',
		reviewRating: 5,
		reviewText:
			'Super easy reservation process. I needed storage for my daughter’s belongings between moving out of her college dorm in May and moving back in in August and I didn’t want to bring all the stuff home (we live in another state), so this was the perfect solution!! Thank you!',
		reviewerName: 'Shelley Van Noy',
		reviewerInitials: 'SN',

		reviewDate: 'Mar 17, 2022',
		link: 'https://www.trustpilot.com/reviews/623273df924ebaa0caee5f3a',
	},
	{
		reviewTitle: 'Easy reservation, scheduling and set-up.',
		reviewRating: 5,
		reviewText:
			"We realized at the last minute we needed a storage option. We found one 5 minutes from our son's college. We scheduled and got set up easily. Good experience.",
		reviewerName: 'KW',
		reviewerInitials: 'KW',

		reviewDate: 'Apr 30, 2021',
		link: 'https://www.trustpilot.com/reviews/608b4ab2f9f4870984afcf00',
	},
];

const collegeStorageFAQs = [
	{
		question: 'How much storage do students need for a typical dorm room?',
		answer: "Most college students find that a 5x10 storage unit provides perfect space for storing a semester's worth of dorm belongings. This size comfortably fits the contents of a standard dorm room, including clothing, textbooks, small furniture like desk chairs, electronics, and personal items.\n\nFor students living in larger dorms or those who've accumulated more possessions over multiple years, a 10x10 unit might be necessary. This size works particularly well for students who need to store larger items like mini fridges, microwaves, or multiple pieces of furniture.\n\nThe key is to think about volume rather than just quantity. Bulky items like comforters, pillows, and winter coats take up more space than their weight might suggest. A good rule of thumb is to measure your dorm room and estimate that you'll need about 60-70% of that space in storage, since you'll be packing items more efficiently than they're arranged for daily use.\n\nStudents who are minimalists or those storing items for just a summer might find a 5x5 unit sufficient, especially if they're only keeping essentials like books, important documents, and off-season clothing. However, if you're unsure between two sizes, it's usually better to go with the larger option—the extra space makes loading and accessing your belongings much easier, and the cost difference is often minimal.",
	},
	{
		question:
			'Which self-storage companies are most popular among students?',
		answer: 'Student preferences for storage companies often depend on factors like location, pricing, and amenities specifically designed for college needs. The most popular self-storage companies among students typically offer features like extended access hours, online booking, and student-friendly pricing structures.\n\nNational chains like Public Storage, Extra Space Storage, and CubeSmart are frequently chosen by students because they offer consistent experiences across different locations—helpful when you might attend college in one city and need storage in another during breaks. These companies often have locations near major universities and understand the unique needs of college students. SpareFoot can connect you with national chains near campus with the click of a button.\n\nLocal storage facilities near college campuses often become popular through word-of-mouth recommendations and may offer more personalized service or competitive pricing for students. These facilities might provide perks like free moving truck rentals or flexible lease terms that align with academic calendars.\n\nMany students also prefer companies that offer month-to-month leases rather than requiring long-term commitments, since academic schedules can be unpredictable. The best storage for students often includes features like climate control (important for electronics and books), security features, and convenient access hours that work with class schedules.\n\nWhen choosing a storage company, students should consider factors beyond just price. Location convenience, security features, customer service quality, and student discounts or special programs all play a key role in finding the right storage for your needs.',
	},
	{
		question:
			"What's the best time to book student storage for summer break?",
		answer: "The optimal time to book student storage for summer break is typically 4-6 weeks before your semester ends, usually around mid-March for spring semester students. This timing gives you the best selection of available units and allows you to secure competitive pricing before peak demand hits.\n\nEarly booking is crucial because student storage demand spikes dramatically in late April and May as finals approach. Many storage facilities near college campuses fill up quickly during this period, and prices may increase due to high demand. By booking early, you can often take advantage of promotional rates and ensure you get a unit in your preferred location.\n\nConsider your academic calendar when booking. If you're planning to return to the same dorm or apartment in the fall, you'll want continuous storage through the summer. However, if you're moving to a new place or graduating, you might only need storage for a few months. Some facilities offer flexible lease terms that can accommodate these different scenarios.\n\nIt's also worth considering the logistics of your move-out and move-in dates. Many colleges have specific move-out deadlines, and you'll want to ensure your storage unit is available before these dates. Similarly, if you're returning to campus early for activities or jobs, you'll need access to your belongings before the general student population returns.\n\nPro tip: Some storage facilities offer special summer storage packages designed specifically for college students, which might include features like free moving supplies, extended access hours during move-out periods, or discounted rates for students who book multiple months in advance.",
	},
	{
		question: 'Can I share a storage unit with my roommate or friends?',
		answer: "Yes, sharing a storage unit with roommates or friends is not only possible but often a smart financial decision for college students. Most storage facilities allow multiple people to access the same unit, though the specific policies vary by company. This arrangement can significantly reduce individual costs and make college storage more affordable for everyone involved.\n\nWhen setting up shared storage, typically one person serves as the primary renter and is responsible for the lease agreement and payments. The other users can be added as authorized individuals who can access the unit. It's important to have clear agreements about who pays what, how expenses are split, and what happens if someone needs to remove their belongings early.\n\nThe most popular shared arrangement is splitting a 10x10 or 10x15 unit among 2-3 roommates, which often costs less per person than individual 5x5 units. This size provides enough space for multiple students' belongings while still being manageable for organization and access.\n\nHowever, sharing storage requires good communication and organization. You'll need to coordinate schedules for accessing the unit, decide how to arrange belongings so everyone can reach their items, and establish ground rules about what can and cannot be stored. Some friends create a simple inventory list or use colored labels to identify whose belongings are whose.\n\nConsider the practical aspects too: if you're sharing with someone who lives far away or has a very different schedule, accessing your belongings might become complicated. It's also important to trust your storage partners, since you'll all have access to each other's belongings.",
	},
	{
		question:
			'What items should college students definitely put in storage vs. keep in their dorm?',
		answer: "Deciding what to store versus what to keep in your dorm requires strategic thinking about space, frequency of use, and seasonal needs. The goal is to keep your dorm functional while protecting valuable or rarely-used items in storage.\n\n **Items Perfect for Storage:** \n- Seasonal clothing (winter coats during spring semester, summer clothes during fall/winter)\n- Extra bedding and linens beyond what you use regularly\n- Books from previous semesters that you want to keep but don't need daily access to\n- Sentimental items like high school yearbooks, awards, or keepsakes\n- Duplicate electronics or appliances (extra lamp, backup printer, etc.)\n- Sports equipment for off-season activities\n- Holiday decorations and non-essential room decor\n- Important documents that need protection but aren't frequently accessed\n\n **Items to Keep in Your Dorm:** \n- Current textbooks and school supplies\n- Daily-use electronics (laptop, phone charger, etc.)\n- Current season clothing and shoes\n- Frequently used kitchen items and toiletries\n- Study materials and reference books for current classes\n- Everyday furniture like your desk chair and main lamp\n\n **Climate-Controlled Storage Considerations:** Electronics, photographs, books, and important documents should ideally be stored in climate-controlled units to prevent damage from temperature fluctuations and humidity. This is especially important in regions with extreme weather or high humidity.\n\nThe key is to evaluate each item based on how often you'll need it. If you haven't used something in the past month and won't need it for the next few months, it's probably a good candidate for storage. Remember, dorm to dorm storage should make your living space more functional, not just serve as an overflow area for things you can't decide about.",
	},
	{
		question:
			'How do I prepare my belongings for long-term student storage?',
		answer: "Proper preparation is essential for protecting your belongings during extended storage periods, especially for summer storage or study abroad situations. Taking time to prepare items correctly can prevent damage and ensure everything is in good condition when you need it again.\n\n **Cleaning and Organizing:** Start by thoroughly cleaning everything before storage. Wash all clothing and linens, wipe down furniture and electronics, and ensure nothing is damp or dirty. Moisture and organic residue can lead to mold, mildew, or pest problems during storage. Pack clean items in sealed containers or vacuum-sealed bags to maximize protection.\n\n **Electronics and Valuable Items:** Remove batteries from electronic devices to prevent corrosion, and if possible, store electronics in their original packaging. For valuable items like laptops or tablets, consider keeping them with you rather than in storage, or invest in a climate-controlled unit. Important documents should be stored in waterproof containers or plastic sleeves.\n\n **Furniture and Large Items:** Disassemble furniture when possible to save space and prevent damage. Store screws and hardware in labeled bags taped to the furniture pieces. Cover furniture with protective blankets or sheets to prevent scratches and dust accumulation. For upholstered items, consider using furniture covers designed for storage.\n\n **Packing Strategy:** Use sturdy boxes and containers, and label everything clearly with contents and your contact information. Create an inventory list of stored items—this helps with insurance claims if needed and makes finding specific items easier. Pack heavy items in smaller boxes to make them easier to move and stack.\n\n **Seasonal Considerations:** For summer storage, pay special attention to items that might be affected by heat. Candles, certain plastics, and some electronics can be damaged by extreme temperatures. If you're storing items long-term, visit your unit periodically to check on everything and ensure there are no issues developing.",
	},
];

export const CollegeContent = {
	type: 'College',
	sections: [
		{
			title: 'College Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					props: {
						content: {
							title: 'Find the Best College Storage For You',
							description:
								'College life is cramped enough without furniture, cleaning supplies, and extra appliances taking up your limited space. Between textbooks, winter clothes, mini fridges, and that bean bag chair you insisted on getting freshman year, finding space for everything feels impossible. But it doesn’t have to be. \n\n [Student storage helps you reclaim your space](https://www.sparefoot.com/blog/how-to-cut-college-clutter) and protects your belongings during chaotic term transitions and semesters abroad. Browse thousands of storage options near campus, compare student self-storage rates instantly, and book online in minutes. ',
							image: CollegeHero,
							CTAText: 'Find College Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular College Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Student Storage Size Guide & Comparisons',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Student Storage Size Guide & Comparisons',
						contentType: 'row-type',
						content: [
							"College students have unique storage needs that change throughout their academic journey. From freshman year essentials to senior year accumulation, [choosing the right storage unit size](https://www.sparefoot.com/storage-unit-size-guide.html) can save you money and stress. \n\n Here's your complete guide to student storage sizes:",
						],
						ShowBackgroundImage: false,
					},
				},
				{
					type: 'sizeChart',
					props: {
						tip: "\n **Pro Student Storage Tip:** If you're splitting costs with a roommate, a 10x10 unit often provides better value than two separate 5x5 units. Plus, you can coordinate your storage schedules for easier access.",
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
							{
								label: 'Monthly Cost Range',
								key: 'Monthly Cost Range',
							},
							{
								label: 'What Fits',
								key: 'What Fits',
							},
						],

						rows: [
							{
								'Unit Size': {
									type: 'icon',
									icon: Unit5x5,
									description:
										'[**5x5**](https://www.sparefoot.com/blog/5x5-storage-unit-size-guide)',
								},
								'Best For': 'Summer storage basics',
								'Monthly Cost Range': '$50-$80',
								'What Fits':
									'Textbooks, clothes, small electronics, the contents of a walk-in closet',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: Unit5x10,
									description:
										'[**5x10**](https://www.sparefoot.com/blog/5x10-storage-unit-size-guide)',
								},
								'Best For': 'Semester transitions',
								'Monthly Cost Range': '$70-$110',
								'What Fits':
									'Dorm room fixtures, mini fridge, desk chair, seasonal clothing',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: Unit10x10,
									description:
										'[**10x10**](https://www.sparefoot.com/blog/10x10-storage-unit-size-guide)',
								},
								'Best For': 'Full dorm cleanout',
								'Monthly Cost Range': '$90-$140',
								'What Fits':
									'Furniture, multiple boxes, sports equipment',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: Unit10x15,
									description:
										'[**10x15**](https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit)',
								},
								'Best For': 'Shared storage',
								'Monthly Cost Range': '$110-$170',
								'What Fits':
									"Two students' belongings, large furniture",
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						content: [
							"**Pro Student Storage Tip:** If you're splitting costs with a roommate, a 10x10 unit often provides better value than two separate 5x5 units. Plus, you can coordinate your storage schedules for easier access.",
						],
						ShowBackgroundImage: false,
						contentType: 'row-type',
					},
				},
			],
		},
		{
			title: 'College-Storage Size Comparison',
			noPaddingTop: true,
			modules: [
				{
					type: 'unitList',
					props: {
						slug: '',
						sectionHeader:
							'Student Storage Benefits: Why Off-Campus Storage Makes Sense',
						unitsData: [
							{
								image: Furniture,
								content:
									'### Beat the Dorm Room Squeeze\n\n' +
									"College dorms weren't designed for the amount of stuff modern students accumulate. The [best storage for students provides breathing room](https://www.sparefoot.com/blog/dorm-storage-for-summer) in cramped quarters, making your living space more functional and less stressful.",
							},
							{
								image: Box,
								content:
									'### Seamless Semester Transitions\n\n' +
									'**Summer Storage Solutions:** Instead of hauling everything back home each semester, secure summer storage keeps your belongings safe and ready for your return. No more begging friends for basement space or cramming everything into your childhood bedroom.',
							},
							{
								image: Summer,
								content:
									'### Study Abroad & Internship Flexibility\n\n' +
									"When opportunities arise, student storage gives you the freedom to say yes without worrying about your belongings. Store your dorm contents safely while you're conquering the world (or at least that internship in another city).",
							},
							{
								image: Camera,
								content:
									'### Protect Your Investment\n\n' +
									"College gear adds up fast. From electronics to textbooks to that expensive coffee maker, dorm to dorm storage (especially climate-controlled storage) protects your investments from damage during moves and keeps them secure when you're not around.",
							},
							{
								image: Grad,
								content:
									'### Graduation Peace of Mind\n\n' +
									'Senior year storage solutions help you transition smoothly from college life to the real world. No rush to find an apartment that fits all your stuff—store what you need while you figure out your next steps.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Student Storage Cost',
			background: 'yellow',
			noPaddingTop: false,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Student Storage Costs (2025)',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Understanding how much student storage costs helps you budget effectively and find the best deals. Here's what you can expect to pay for college storage in 2025:",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						title: 'Average Monthly Costs by Storage Type',
						headers: [
							{
								label: 'Storage Type',
								key: 'Storage Type',
							},
							{
								label: 'Small (5x5)',
								key: 'Small (5x5)',
							},
							{
								label: 'Medium (5x10)',
								key: 'Medium (5x10)',
							},
							{
								label: 'Large (10x10)',
								key: 'Large (10x10)',
							},
							{
								label: 'Shared (10x15)',
								key: 'Shared (10x15)',
							},
						],
						rows: [
							{
								'Storage Type': {
									type: 'icon',
									icon: Garage,
									heading: 'Standard Units',
								},
								'Small (5x5)': '$50-$80',
								'Medium (5x10)': '$70-$110',
								'Large (10x10)': '$90-$140',
								'Shared (10x15)': '$110-$170',
							},
							{
								'Storage Type': {
									type: 'icon',
									icon: CC,
									heading: 'Climate-Controlled',
								},
								'Small (5x5)': '$70-$100',
								'Medium (5x10)': '$90-$130',
								'Large (10x10)': '$110-$160',
								'Shared (10x15)': '$130-$200',
							},
							{
								'Storage Type': {
									type: 'icon',
									icon: Camera,
									heading: 'Premium Security',
								},
								'Small (5x5)': '$60-$90',
								'Medium (5x10)': '$80-$120',
								'Large (10x10)': '$100-$150',
								'Shared (10x15)': '$120-$180',
							},
						],
					},
				},
			],
		},
		{
			title: 'Cost-Saving Tips for Student Storage',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Cost-Saving Tips for Student Storage',
						contentType: 'row-type',
						content: [
							`**Summer Storage Specials:** Many facilities offer discounts during peak summer months when student demand is highest. Book early with SpareFoot for the best rates. \n\n **Group Storage:** Splitting a 10x10 unit with roommates often costs less per person than individual 5x5 units. \n\n **Long-Term Discounts:** Planning to use a storage unit for multiple semesters? Many facilities offer discounts for longer commitments. \n\n **Student Discounts:** Some self-storage companies offer special rates for college students.`,
						],
						ShowBackgroundImage: false,
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Join Countless Others Using SpareFoot to Score College Storage Deals',
					},
				},
			],
		},
		{
			title: 'Inline CTA',
			noPadding: true,
			modules: [
				{
					type: 'inlineCTA',
					props: {
						title: 'Find the Best College Storage For You',
						theme: 'light',
					},
				},
			],
		},
		{
			title: 'FAQ Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'College Student Storage FAQs',
						faqs: collegeStorageFAQs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'Self Storage',
								date: 'September 10. 2025',
								image: Featured1,
								link: 'https://www.sparefoot.com/blog/college-summer-storage-tips',
								content:
									'College Summer Storage: Your Ultimate Guide to Affordable Student Storage Tips',
							},
							{
								title: 'Moving Tips',
								date: 'July 8, 2025',
								image: Featured2,
								link: 'https://sparefoot.com/blog/storage-tips-for-college-students',
								content:
									'Back-to-School Storage and Organization Tips for College Students',
							},
							{
								title: 'Self Storage',
								date: 'September 2, 2025',
								image: Featured3,
								link: 'https://sparefoot.com/blog/8-things-every-graduate-needs-first-post-college-apartment',
								content:
									'8 Things Every Graduate Needs For Their First Post-College Apartment',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'24Hour',
							'Portable',
							'Bicycle',
							'DriveUp',
							'Car',
							'Electricity',
							'Vehicle',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
